/**
 * Created by mauget on 1/31/16.
 */

// PropertyViewMapService.js

import _         from 'lodash';
import Immutable from 'immutable';
import listService from 'ListService';
import propertyViewMap from 'PropertyViewMap.js';
import constants       from 'Constants.js';
import utils        from 'util/Util.js';

//=========================================================================================
// This service provides a read-only property view mapping structure for control
// view factories.
// -Lou Mauget, January 31, 2016
//=========================================================================================
class PropertyViewMapService {
    constructor() {

        // Build immutable structure from raw object structure
        //this._viewMap = Immutable.Map( rawRoot );
        //this._mainViewMap = Immutable.Map( mainRoot );
        this._styleViewMap = Immutable.Map( propertyViewMap.getStyleRoot() );
        this._mobileStyleViewMap = Immutable.Map( propertyViewMap.getMobileStyleRoot() );
        //this._navigationViewMap = Immutable.Map( navigationRoot );
        //this._behaviorViewMap = Immutable.Map( behaviorRoot );
        //this._advancedViewMap = Immutable.Map( advancedRoot );
        this._attributeViewMap = Immutable.Map( propertyViewMap.getAttributeRoot() );
        this._settingsViewMap = Immutable.Map( propertyViewMap.getSettingsRoot() );
        this._accessViewMap = Immutable.Map( propertyViewMap.getAccessRoot() );
        this._themeViewMap = Immutable.Map( propertyViewMap.getThemeRoot() );
        this._behaviorSettingsMap = Immutable.Map( propertyViewMap.getBehaviorSettingsRoot() );
        this._behaviorSummaryMap = Immutable.Map( propertyViewMap.getBehaviorSummaryRoot() );
        
        this._settingsMobileMap = Immutable.Map( propertyViewMap.getSettingsMobileRoot() );
        this._settingsTabletMap = Immutable.Map( propertyViewMap.getSettingsTabletRoot() );
        this._settingsPhoneMap = Immutable.Map( propertyViewMap.getSettingsPhoneRoot() );
        
         this._sharedSettingsPhoneMap = Immutable.Map( propertyViewMap.getSharedSettingsPhoneRoot() );
        this._sharedSettingsTabletMap = Immutable.Map( propertyViewMap.getSharedSettingsTabletRoot() );
        this._workflowSettingsMap = Immutable.Map( propertyViewMap.getWorkflowSettingsRoot() );
        this._workflowSummaryMap = Immutable.Map( propertyViewMap.getWorkflowSummaryRoot() );
        this._multiselectExceptions = Immutable.Map({
            attributes:['#propMainName'],
            settings:['#propNavTabbing']
        });
    }

    clearMaps() {
        this._styleViewMap = undefined;
        this._mobileStyleViewMap = undefined;
        this._attributeViewMap = undefined;
        this._settingsViewMap = undefined;
        this._accessViewMap = undefined;
        this._themeViewMap = undefined;
        this._behaviorSettingsMap = undefined;
        this._behaviorSummaryMap = undefined;
        this._settingsMobileMap = undefined;
        this._settingsTabletMap = undefined;
        this._settingsPhoneMap = undefined;
        this._sharedSettingsPhoneMap = undefined;
        this._sharedSettingsTabletMap = undefined;
        this._workflowSettingsMap = undefined;
        this._workflowSummaryMap = undefined;
    }

    // These properties ordinarily needed only by unit tests, or to enumerate entire list of theme pairs.
    //get viewMap() { return this._viewMap;}
    //get mainViewMap() { return this._mainViewMap;}
    get styleViewMap() { return this._styleViewMap;}
    get mobileStyleViewMap() { return this._mobileStyleViewMap;}
    //get navigationViewMap() { return this._navigationViewMap;}
    //get behaviorViewMap() { return this._behaviorViewMap;}
    //get advancedViewMap() { return this._advancedViewMap;}
    get attributeViewMap() { return this._attributeViewMap;}
    get themeViewMap() { return this._themeViewMap;}

    //==================================================================
    // A control supplies its key (e.g. 'control_large_heading'),
    // receiving a JS array of its BackBone property views.
    //==================================================================
    getMainViews(controlKey ) {
        //const list =  this._mainViewMap.get( controlKey, Immutable.List() );
        //return [];
    }

    getStyleViews(controlKey ) {
        const list =  this._styleViewMap.get( controlKey, Immutable.List() );
        return list;
    }

    getMobileStyleViews(controlKey ) {
        const list =  this._mobileStyleViewMap.get( controlKey, Immutable.List() );
        return list;
    }

    getNavigationViews(controlKey ) {
        //const list =  this._navigationViewMap.get( controlKey, Immutable.List() );
        //return [];
    }

    getBehaviorViews(controlKey ) {
        const list =  this._behaviorViewMap.get( controlKey, Immutable.List() );
        return list;
    }

    getAdvancedViews(controlKey ) {
        //const list =  this._advancedViewMap.get( controlKey, Immutable.List() );
        //return list;
    }

    getAttributeViews(controlKey ) {
        const list =  this._attributeViewMap.get( controlKey, Immutable.List() );
        return list;
    }

    getSettingsViews(controlKey ) {
        const list =  this._settingsViewMap.get( controlKey, Immutable.List() );
        return list;
    }

    getSettingsMobileViews(controlKey) {
        const list = this._settingsMobileMap.get( controlKey, Immutable.List() );
        return list;
    }

    getSettingsTabletViews(controlKey) {
        const list = this._settingsTabletMap.get( controlKey, Immutable.List() );
        return list;
    }

    getSettingsPhoneViews(controlKey) {
        const list = this._settingsPhoneMap.get( controlKey, Immutable.List() );
        return list;
    }

    getThemeViews(controlKey ) {
        const list =  this._themeViewMap.get( controlKey, Immutable.List() );
        return [];
    }


    getAccessViews(controlKey ) {
        const list =  this._accessViewMap.get( controlKey, Immutable.List() );
        return list;
    }

    getBehaviorSettingsViews(controlKey) {
        const list =  this._behaviorSettingsMap.get( controlKey, Immutable.List() );
        return list;
    }

    getBehaviorSummaryViews(controlKey) {
        const list =  this._behaviorSummaryMap.get( controlKey, Immutable.List() );
        return list;
    }

    getSharedTabletSettings(controlKey) {
        const list =  this._sharedSettingsTabletMap.get( controlKey, Immutable.List() );
        return list;
    }

    getSharedPhoneSettings(controlKey) {
        const list =  this._sharedSettingsPhoneMap.get( controlKey, Immutable.List() );
        return list;
    }

    getWorkflowSettingsViews(controlKey ) {
        const list =  this._workflowSettingsMap.get( controlKey, Immutable.List() );
        return list;
    }

    getWorkflowSummaryViews(controlKey ) {
        const list =  this._workflowSummaryMap.get( controlKey, Immutable.List() );
        return list;
    }

    _silencePropertyViews(id, type) {
        let views = listService.getPropertyViews(id, type);
        if (views) {
            views.map(v => {
                v.close();
                //v.remove();
            });
            //listService.addPropertyViews([], id);
        }
    }

    _renderPropertyViews(views, model, type) {
        let pViews = listService.getPropertyViews(model.get('id'), type);
        if (pViews) {
            console.log('render cached views');
            pViews.map(v => {
                v.render();
            });

        } else {
            if (views) {
                console.log('render new views');
                pViews = [];
                views.map(v => {
                    var obj = new v.view({model: model, el: $(v.el), config: v.config});
                    obj.render();

                    // store the view so we can access later
                    pViews.push(obj);
                });
                //listService.addPropertyViews(pViews, model.get('id'), type);
            }
        }
    }

    // filter to only the common views across what controls are currently selected.
    getMultipleSelectedSettingsViews() {
        let combinedViews = Immutable.Map(),
            allControls = [];

        for ( let view of listService.selected.values() ) {
            allControls.push(view.model.get('factoryKey'));
        }

        const kindOfControls = new Set(allControls);
        if (kindOfControls.size >1) {
            switch (listService.mainKind) {
                case constants.KIND_LAYOUT:
                    utils.updateHelpDocumentationLink('form_group');
                    break;
                case constants.KIND_REPORT:
                    utils.updateHelpDocumentationLink('report_group');
                    break;
                default: break;
            }
        } else {
            utils.updateHelpDocumentationLink(allControls[0]);
        }

        // ------
        // Reports don't share any settings... skip the entire section
        // ------ 
        if ( _.intersection(constants.REPORT_CONTROLS_KEYS, allControls).length ) {
            return combinedViews;
        }  

        // collect all views from controls, eliminate any that are not in ALL
        listService.selected.map((v, k) => {
            if (combinedViews.size === 0) {
                const _views1 = _.clone( this.getSettingsViews(v.model.get('factoryKey')) );
                _views1.map((v,k) => combinedViews = combinedViews.set(k,v) );
            } else {
                const _views = _.clone( this.getSettingsViews(v.model.get('factoryKey')) );
                combinedViews.map((v, k) => {
                    const filter = (view) => {
                        //return (view.view.name === v.view.name);
                        return v.el === view.el;
                    };

                    if (_views.filter(filter).length === 0) {
                        combinedViews = combinedViews.delete(k);
                    }
                    if ( _.includes( this._multiselectExceptions.get('settings'), v.el) ) {
                        combinedViews = combinedViews.delete(k);
                    }
                });
            }
        });

        // ----
        // Special Scenarios: REMOVING PROPERTIES
        // ----

        // SS: remove position settings from settings TAB
        if ( _.includes(allControls, 'control_mask_text_input') && _.includes(allControls, 'control_date_input') ) {
            combinedViews.map((view, key)=>{
                if (view.el === '#propNavPosition') {
                    combinedViews = combinedViews.delete(key);
                }
            });
        }

        // SS: remove position
        if ( _.includes(allControls, 'control_numeric_input') && _.includes(allControls, 'control_mask_text_input') ) {
            combinedViews.map((view, key)=>{
                if (view.el === '#propNavPosition') {
                    combinedViews = combinedViews.delete(key);
                }
            });
        }

        // SS: group + button: remove accesibility
        if ( _.includes(allControls, 'control_group') && ( _.includes(allControls, 'control_button') || _.includes(allControls, 'control_captcha') ) ) {
            combinedViews.map((view, key)=>{
                if (view.el === '#propAccessibility') {
                    combinedViews = combinedViews.delete(key);
                }
            });
        }

        // SS: drop down + mask: remove position
        if ( _.includes(allControls, 'control_drop_down') && _.includes(allControls, 'control_mask_text_input') ) {
            combinedViews.map((view, key)=>{
                if (view.el === '#propNavPosition') {
                    combinedViews = combinedViews.delete(key);
                }
            });
        }

        // SS: show form button + progress bar: remove accesibility
        if ( _.includes(allControls, 'control_play_form_button') && _.includes(allControls, 'control_progress_bar') ) {
            combinedViews.map((view, key)=>{
                if (view.el === '#propAccessibility') {
                    combinedViews = combinedViews.delete(key);
                }
            });
        }

        return combinedViews;
    }

    // filter to only the common style settings across what controls are currently selected.
    getMultipleSelectedStyleViews() {
        let combinedViews = Immutable.Map(),
            allViews = Immutable.Map(),
            _allViewsAsArray = [],
            allControls = [];
        
        for ( let view of listService.selected.values() ) {
            allControls.push(view.model.get('factoryKey'));
        }

        // ------ 
        // Reports don't share any styles... skip the entire section
        // ------ 
        if ( _.intersection(constants.REPORT_CONTROLS_KEYS, allControls).length ) {
            return combinedViews;
        }

        listService.selected.map((v, k) => {
            const elementViews = [];
            let _views = _.clone( this.getStyleViews(v.model.get('factoryKey')) );

            // ++++
            // Special Scenarios: ADDING PROPERTIES
            // ++++

            // SS: date input + control progress bar: add text
            if (v.model.get('factoryKey') === 'control_progress_bar' && _.includes(allControls, 'control_date_input')) {
                let listOfViews = this._styleViewMap.get( 'control_text_input', Immutable.List() );
                _views.unshift(listOfViews[0]);
            }

            // SS: time input + progress bar: add text
            if (v.model.get('factoryKey') === 'control_progress_bar' && _.includes(allControls, 'control_time_input')) {
                let listOfViews = this._styleViewMap.get( 'control_text_input', Immutable.List() );
                _views.unshift(listOfViews[0]);
            }

            // ----
            // Special Scenarios: REMOVING PROPERTIES
            // ----
            
            // date input + captcha: remove text
            if (v.model.get('factoryKey') === 'control_captcha' && _.includes(allControls, 'control_date_input')) {
                _.remove(_views, (view)=>{ return view.el === '#propStyleText'; });
            }

            // date input + mask text: remove text
            if (v.model.get('factoryKey') === 'control_mask_text_input' && _.includes(allControls, 'control_date_input')) {
                _.remove(_views, (view)=>{ return view.el === '#propStyleText'; });
            }

            // group + assorted inputs: remove text and border
            if (_.includes(allControls, 'control_text_input') && _.intersection(allControls, constants.GROUPS_CONTROLS_KEYS).length ) {
                _.remove(_views, (view)=>{ return _.includes(['#propStyleText', '#propStyleBackground'],view.el); });
            }

            // group + table: remove header & background
            if (_.includes(allControls, 'control_table') && _.intersection(allControls, constants.GROUPS_CONTROLS_KEYS).length ) {
                _.remove(_views, (view)=>{ return _.includes(['#propStyleHeaderBGColor', '#propStyleBackground'],view.el); });
            }

            // time input + captcha: remove text
            if (v.model.get('factoryKey') === 'control_time_input' && _.includes(allControls, 'control_captcha')) {
                _.remove(_views, (view)=>{ return view.el === '#propStyleText'; });
            }

            // drop down + mask: remove text
            if (v.model.get('factoryKey') === 'control_drop_down' && _.includes(allControls, 'control_mask_text_input')) {
                _.remove(_views, (view)=>{ return view.el === '#propStyleText'; });
            }

            // drop down OR captcha OR checkbox OR sliders + group: remove text + background
            if ( _.includes(['control_drop_down', 'control_captcha', 'control_checkbox', 'control_vertical_slider', 'control_horizontal_slider'], v.model.get('factoryKey')) && _.intersection(allControls, constants.GROUPS_CONTROLS_KEYS).length) {
                _.remove(_views, (view)=>{ return _.includes(['#propStyleText', '#propStyleBackground'],view.el); });
            }

            // show form button + progress bar: remove border
            if (v.model.get('factoryKey') === 'control_play_form_button' && _.includes(allControls, 'control_progress_bar')) {
                _.remove(_views, (view)=>{ return view.el === '#propStyleBorder'; });
            }

            // show form button + progress bar: remove text
            if (v.model.get('factoryKey') === 'control_numeric_input' && ( _.includes(allControls, 'control_checkbox') || _.includes(allControls, 'control_radio_button') )) {
                _.remove(_views, (view)=>{ return view.el === '#propStyleText'; });
            }

            if(_views.length){
                _views.forEach((node, id)=>{
                    elementViews.push(node.el);
                    allViews = allViews.set(id, node);
                });
            }

            _allViewsAsArray.push(elementViews);
        });
        
        let newArrayOfElements = _allViewsAsArray[_allViewsAsArray.length-1];

        for (let i=_allViewsAsArray.length-1 ; i-- ;  ) {
            newArrayOfElements = _.intersection(newArrayOfElements,_allViewsAsArray[i]);
        }
        
        // need the full details of each view
        for (let el in newArrayOfElements) {
            allViews.map(view=>{
                if (view.el === newArrayOfElements[el]) {
                    combinedViews = combinedViews.set(el,view);
                }
            });
        }

        // Special Scenario: Removing "background" style placeholder when it's not needed (no background children properties)
        if (_.includes(newArrayOfElements, '#propStyleBackground')) {
            const backgroundStyleProperty = newArrayOfElements.filter( i=>i.match(/Background/) );
            if (backgroundStyleProperty.length === 1) { // means, background placeholder is alone
                combinedViews.map((view, key)=>{
                    if (view.el === '#propStyleBackground') {
                        combinedViews = combinedViews.delete(key);
                    }
                });
            }
        }

        // Special Scenarios: add color picker for text & link
        const isATextView = _.intersection(allControls, constants.TEXT_CONTROLS_KEYS);
        if ( ( _.includes(allControls, 'control_link') && isATextView.length ) || 
            ( _.includes(allControls, 'control_link')) ) {
            const styleColorView = this.getStyleViews('control_text').filter((i)=>{ return i.el === '#propStyleTextColor'; });
            combinedViews = combinedViews.set(combinedViews.size+1, styleColorView[0]);
        }

        // Special Scenarios: remove text setting from style TAB
        if ( (_.includes(allControls, 'control_numeric_input') && _.includes(allControls, 'control_mask_text_input') )
            || ( _.includes(allControls, 'control_date_input') && ( _.includes(allControls, 'control_checkbox') || _.includes(allControls, 'control_radio_button') ) )
            ) {
            combinedViews.map((view, key)=>{
                if (view.el === '#propStyleText') {
                    combinedViews = combinedViews.delete(key);
                }
            });
        }

        return combinedViews;
    }

    // filter to only the common views across what controls are currently selected.
    getMultipleSelectedAccessViews() {
        let combinedViews = Immutable.Map();

        // collect all views from controls, eliminate any that are not in ALL
        listService.selected.map((v, k) => {
           if (combinedViews.size === 0) {
               const _views1 = _.clone( this.getAccessViews(v.model.get('factoryKey')) );
               _views1.map((v,k) => {
                   combinedViews = combinedViews.set(k,v);
               })
           } else {
               const _views = _.clone( this.getAccessViews(v.model.get('factoryKey')) );
               combinedViews.map((v, k) => {
                   const filter = (view) => {
                       return v.el === '#propAccessState' || v.el === '#propAccessHidden';
                   };

                  if (_views.filter(filter).length === 0) {
                      combinedViews = combinedViews.delete(k);

                  }
               });
           }
        });
        return combinedViews;
    }

    getMultipleSelectedAttributesViews() {
        let combinedViews = Immutable.Map();
        let allModels = [];

        // collect all views from controls, eliminate any that are not in ALL
        listService.selected.map((v, k) => {
            allModels.push( v.model.get('factoryKey') );
           if (combinedViews.size === 0) {
               const _views1 = _.clone( this.getAttributeViews(v.model.get('factoryKey')) );
               _views1.map((v,k) => combinedViews = combinedViews.set(k,v) );
           } else {
               const _views = _.clone( this.getAttributeViews(v.model.get('factoryKey')) );
               combinedViews.map((v, k) => {
                   const filter = (view) => {
                       return v.el === view.el;
                   };

                    if (_views.filter(filter).length === 0) {
                        combinedViews = combinedViews.delete(k);
                    }
               });
           }
        });

        // SPECIAL SCENARIOS
        combinedViews.map((v, k) => {
            if ( _.includes( this._multiselectExceptions.get('attributes'), v.el) ) {
                combinedViews = combinedViews.delete(k);
            }
        });

        if ( (_.includes(allModels, 'control_text_input') && _.includes(allModels, 'control_multiple_text_input') )
            || (_.includes(allModels, 'control_bullet_text') && _.intersection(allModels, constants.TEXT_CONTROLS_KEYS).length) ) {
            combinedViews.map((v, k) => {
                if (v.el === '#propMainText') {
                    combinedViews = combinedViews.delete(k);
                }
            });
        }

        if ( ( _.includes(allModels, 'control_link') && _.intersection(allModels, constants.TEXT_CONTROLS_KEYS).length ) 
            || ( _.includes(allModels, 'control_bullet_text') && _.intersection(allModels, constants.TEXT_CONTROLS_KEYS).length )  ) {
            const attrTextView = this.getAttributeViews('control_text').filter((i)=>{ return i.el === '#propMainText'; });
            combinedViews = combinedViews.set(combinedViews.size+1, attrTextView[0]);
        }

        if ( _.includes(allModels, 'control_link') && _.includes(allModels, 'control_bullet_text') ) {
            
            const attrTextView = this.getAttributeViews('control_text').filter((i)=>{ return i.el === '#propMainText'; });
            combinedViews = combinedViews.set(combinedViews.size+1, attrTextView[0]);
        }

        return combinedViews;
    }
}




const propertyViewMapService = new PropertyViewMapService();
export default propertyViewMapService;
